/**
 * LoginPage.js
 *
 * Trim de hay-hotspot/assets/reactweb/src/pages/Login/LoginPage.js (Fase 1.6) — removida a
 * seleção de grupo (`selecionarGrupo`/`grupos`, fluxo hotspot de usuário com múltiplos vínculos)
 * já que `Usuario.login` do LinkInsight sempre resolve um único UsuarioGrupo por publicação
 * (ver decisão de escopo "login simples", Fase 1.4).
 */
import React, { Component } from 'react';
import lodash from 'lodash';

import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Divider } from 'primereact/divider';

import { ModelTextInput } from 'hay-core-react';
import { ModelSenha } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import LogoInicial from '../../images/LogoInicial.png';
import { withRouter } from 'hay-core-react';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      model: {
        identificador: {
          value: '',
          erro: '',
          exibir: 'login.identificador',
          validacao: { obrigatorio: true },
        },
        senha: {
          value: '',
          erro: '',
          exibir: 'login.senha',
          validacao: { obrigatorio: true, tamanhominimo: 6 },
        },
      },
      erroGeral: '',
      carregando: false,
    };
  }

  async componentDidMount() {
    const auth = UtilService.getLocalStorage('auth');
    if (!auth?.token) return;
    const resultado = await ApiService.autorizar();
    const result = resultado?.data;
    if (result?.nome && result?.token) {
      UtilService.saveLocalStorage('auth', { ...auth, ...result });
      this.props.setPermissoes && this.props.setPermissoes({ ...(result?.permissoes || {}), permiteacessogeral: result?.permiteacessogeral, acessototal: result?.acessototal }, () => {
        this.navegarPosLogin();
      });
    }
  }

  navegarPosLogin() {
    const destino = this.props.searchparams?.get('destino');
    if (destino) {
      const [pathname, search] = destino.split('?');
      return this.props.navigate({
        pathname,
        search: search ? Object.fromEntries(new URLSearchParams(search)) : undefined,
      });
    }
    this.props.navigate({ pathname: '/dashboard' });
  }

  traduzir(chave) {
    return UtilService.traduzir(chave);
  }

  traduzirModel(model) {
    return this.traduzir(model.exibir);
  }

  traduzirHelp() {
    return '';
  }

  getRenderer() {
    return null;
  }

  updateModelPath(path, valor) {
    this.setState(prevState => {
      const obj = lodash.cloneDeep(prevState.model);
      lodash.set(obj, path, valor);
      return { model: obj };
    });
  }

  async handleSubmit() {
    const model = UtilService.validarEsquema(this.state.model);
    this.setState({ model, erroGeral: '' });
    if (!model.valido) return;

    this.setState({ carregando: true });

    const result = await ApiService.login(model.identificador.value.trim(), model.senha.value);

    if (result?.status && result?.data?.token) {
      UtilService.saveLocalStorage('auth', result.data);
      this.props.setPermissoes && this.props.setPermissoes({ ...(result.data.permissoes || {}), permiteacessogeral: result.data.permiteacessogeral, acessototal: result.data.acessototal }, () => {
        this.navegarPosLogin();
      });
    } else {
      this.setState({
        carregando: false,
        erroGeral: result?.data?.message || this.traduzir('login.erro.credenciais'),
      });
    }
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') this.handleSubmit();
  }

  render() {
    const { model, erroGeral, carregando } = this.state;

    return (
      <div className="min-h-screen flex align-items-center justify-content-center surface-ground px-3 py-3 ">
        <div
          className="surface-card border-round-2xl shadow-4 w-full p-5 md:p-6"
          style={{ maxWidth: '440px' }}
        >
          <div className="flex flex-column align-items-center mb-5">
            <img
              src={LogoInicial}
              alt="HaY Systems"
              style={{ objectFit: 'contain' }}
              className="w-full mb-3"
            />
            <span className="font-bold text-3xl text-primary">HaY LinkInsight</span>
            <span className="text-500 text-sm mt-1">{this.traduzir('login.subtitulo')}</span>
          </div>

          <Divider className="mt-4 mb-5" />

          <div className="field mb-5" onKeyDown={e => this.handleKeyDown(e)}>
            <ModelTextInput model={model.identificador} contexto={this} />
          </div>

          <div className="field mb-2" onKeyDown={e => this.handleKeyDown(e)}>
            <ModelSenha model={model.senha} contexto={this} mostrarMetricas={false} />
          </div>

          <div className="flex justify-content-end mb-5">
            <Button label={this.traduzir('login.esqueci.senha')} link onClick={() => this.props.navigate({ pathname: '/esqueci-senha' })} className="p-0" size="small" />
          </div>

          {erroGeral && (
            <Message
              severity="error"
              text={erroGeral}
              className="w-full mb-4"
              style={{ justifyContent: 'flex-start' }}
            />
          )}

          <Button
            label={this.traduzir('login.entrar')}
            icon="pi pi-sign-in"
            loading={carregando}
            onClick={() => this.handleSubmit()}
            className="w-full"
            size="small"
          />
        </div>
      </div>
    );
  }
}

export default withRouter(LoginPage);
